import React from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import CloseButton from "react-bootstrap/CloseButton";
import Button from "react-bootstrap/Button";
import { styled } from "@mui/system";
import { ModalSuccessLogo, ModalBottomLogo } from "../assets/icons";
import {
  DISPLAY_BLOCK,
  DISPLAY_FLEX,
  FLEX_ALIGN_CENTER,
  FLEX_DIRECTION_ROW,
  FLEX_JUSTIFY_CENTER,
  MAX_WIDTH,
  TEXT_ALIGN_CENTER,
  FLEX_JUSTIFY_SPACE_BETWEEN,
  BORDER_PRIMARY,
} from "../config/styles";
import { Typography } from "@mui/material";
import { colors } from "../config/colors";

const DownloadReportStyled = styled(Modal)(({ theme }) => ({
  width: "408px",
  margin: "0 auto",
  "& .custom-modal": {
    width: "408px !important",
    margin: "0 auto !important",
  },
  "& .modal-header": {
    borderBottom: "none",
    backgroundColor: theme.palette.primary.main,
    height: "159px",
    alignItems: "start",
    display: DISPLAY_BLOCK,
  },
  "& .modal-header-wrapper": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    justifyContent: FLEX_JUSTIFY_CENTER,
    alignItems: FLEX_ALIGN_CENTER,
    width: MAX_WIDTH,
    paddingTop: "8px",
  },
  "& .modal-body": {
    padding: "20px",
    textAlign: "center",
    fontSize: "16px",
    color: theme.palette.text.primary,
  },
  "& .edit-button-btn": {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.secondary.contrastText,
    border: BORDER_PRIMARY,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  "& .modal-button-container": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    alignItems: FLEX_JUSTIFY_CENTER,
    justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
    padding: "20px",
  },
}));

export const DownloadReport = ({
  show,
  onHide,
  title,
  message,
}) => {
  return (
    <DownloadReportStyled
      show={show}
      onHide={onHide}
      centered
      contentClassName="custom-modal"
    >
      <Modal.Header bsPrefix="modal-header">
        <div className="d-flex justify-content-end w-100">
          <CloseButton variant="white" onClick={onHide} />
        </div>
        <div className="modal-header-wrapper">
          <ModalSuccessLogo />
        </div>
        <div style={{ marginTop: "48px", textAlign: TEXT_ALIGN_CENTER }}>
          <ModalBottomLogo />
        </div>
      </Modal.Header>

      <Modal.Body className="py-4">
        <Typography variant="body2" className="w-100 ">
          {title}
        </Typography>
        <Typography
          variant="subitle2"
          className="w-100 mt-3"
          component="p"
          sx={{ color: colors.grayLight }}
        >
          {message}
        </Typography>
      </Modal.Body>
      <div className="modal-button-container">
        <Button
          className="edit-button-btn"
          onClick={onHide}
          style={{ width: MAX_WIDTH }}
        >
          Close
        </Button>
      </div>
    </DownloadReportStyled>
  );
};
DownloadReport.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};
